import React from 'react'

export default function ScubaOWNewPage() {
  return <div>test</div>
}
